import React, { Fragment, useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { ContextDetails } from './ContextDetails'
import { NewCourseModal } from './NewCourseModal'
import { useStateValue } from '@State'

export const ContextContainer = props => {
  const [newCourseModalOpen, toggleModal] = useState(false)
  const [dispatch] = useStateValue()

  const hideTools = () => {
    dispatch({
      type: 'hideContextTools',
      showContextTools: null,
    })
  }

  return (
    <Fragment>
      <div className="card-myed">
        <div className="pull-right">
          <Link
            onClick={hideTools}
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed mr-4"
            to={`/account/admin_lti_org_key_management/-/organizations/${props.match.params.orgId}/`}
          >
            <div className="fa-regular fa-arrow-circle-left fa-fw mr-2" /> Go Back
          </Link>
          <div
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
            onClick={() => toggleModal(!newCourseModalOpen)}
          >
            <div className="fa-regular fa-plus fa-fw mr-2" /> Add New Course
          </div>
        </div>
        <h3>Context Details</h3>
        <ContextDetails contextId={props.match.params.contextId} />
      </div>
      <NewCourseModal
        contextPk={props.match.params.contextId}
        show={newCourseModalOpen}
        toggle={toggleModal}
      />
    </Fragment>
  )
}

ContextContainer.propTypes = {
  match: PropTypes.object,
}
